/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AdminCell_lists$ref = any;
type AdminCell_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AdminList_lists$ref: FragmentReference;
declare export opaque type AdminList_lists$fragmentType: AdminList_lists$ref;
export type AdminList_lists = {|
  +adminUsers: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: AdminCell_user$ref,
      |}
    |}>
  |},
  +$fragmentRefs: AdminCell_lists$ref,
  +$refType: AdminList_lists$ref,
|};
export type AdminList_lists$data = AdminList_lists;
export type AdminList_lists$key = {
  +$data?: AdminList_lists$data,
  +$fragmentRefs: AdminList_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "adminUsers"
        ]
      }
    ]
  },
  "name": "AdminList_lists",
  "selections": [
    {
      "alias": "adminUsers",
      "args": null,
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "__AdminList_adminUsers_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "AdminCell_user"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AdminCell_lists"
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '9fe9dd4a85022d66649004c5702bf0af';

module.exports = node;
